/* eslint-disable import/first */
import 'babel-polyfill';
import Vue from 'vue';
import VueGtm from 'vue-gtm';
import Vuetify from 'vuetify';
import VueScrollTo from 'vue-scrollto';
import moment from 'moment';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { isObject, isString, values, flatten } from 'lodash';
import BluebirdPromise from 'bluebird';
import NProgress from 'nprogress';

BluebirdPromise.config({
  warnings: false,
});
window.Promise = BluebirdPromise;

import 'vuetify/dist/vuetify.min.css';
import 'mdi/css/materialdesignicons.min.css';
import 'nprogress/nprogress.css';
import 'vue2vis/dist/vue2vis.css';
import 'video.js/dist/video-js.min.css';
import 'vue-video-player-videojs-7/src/custom-theme.css';
import 'videojs-overlay/dist/videojs-overlay.css';
import '@/assets/css/mistercalcio.css';

NProgress.configure({
  showSpinner: false,
});

import './lib/axios';

import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';

moment.locale(i18n.locale);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtm, {
    id: 'GTM-TSR4KVG',
    enabled: true,
    debug: false,
    vueRouter: router,
  });
}

Vue.use(Vuetify, {
  theme: {
    primary: '#2E6495',
  },
});
Vue.use(VueScrollTo);

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.SENTRY_URL,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

function parseResponseErrors(err) {
  if (err.response) {
    if (isObject(err.response.data.error) && isObject(err.response.data.error.errors)) {
      return flatten(values(err.response.data.error.errors)).join('<br />');
    } else if (isString(err.response.data.error)) {
      return err.response.data.error;
    }

    return i18n.t(`errors.error${err.response.status}`);
  } else if (err.request) {
    return i18n.t('errors.error500');
  }

  if (process.env.NODE_ENV === 'production') Sentry.captureException(err);
  throw err;
}

Vue.prototype.$notification = function notification(opts) {
  this.$store.commit('notification', opts);
};

Vue.prototype.$parseErrorWithNotification = function parseErrorWithNotification(err) {
  const parsedError = parseResponseErrors.call(this, err);
  this.$notification({
    text: parsedError,
    color: 'error',
  });
};

// components
// const TelegramSendButton = Vue.component('TelegramSendButton', require('@/components/telegram/SendButton').default);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js